import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './RadioFormOption.module.css';

export default class RadioFormOptions extends Component {
  render() {
    let discount = this.props.discount;
    let discountRate = this.props.discountRate;
    const listRadioItems = this.props.radioProps.map((i, index) => (
      <div
        className={[
          `${styles.radioInput} ${this.props.inline && styles.inlineContainer}`,
        ]}
        key={index}>
        <input
          type="radio"
          id={i.value}
          name={this.props.name}
          value={i.value}
          disabled={this.props.isCurrentMembershipTier === i.id}
          checked={i.value.toString() === this.props.value}
          onChange={(val) => this.props.onValueChange(val.target.id, index)}
        />
        <label htmlFor={i.value}>{i.label}</label>
        <div className={[styles.valueText]}>
          {discountRate && this.props.isCurrentMembershipTier !== i.id && (
            <small>{-discountRate}%</small>
          )}
          {this.props.isCurrentMembershipTier === i.id
            ? 'Current'
            : `$${i.value?.toFixed(2)}`}
        </div>
        <div>
          {' '}
          <img className={styles.icon} src={i.icon} />
        </div>
      </div>
    ));
    return (
      <form className={`${styles.container} ${this.props.className}`}>
        <p className="formLabel">{this.props.label}</p>
        <p className="bodyCopyForm">{this.props.desc}</p>
        {listRadioItems}
        <p className={`errorMessage ${styles.error}`}>{this.props.error}</p>
      </form>
    );
  }
}

RadioFormOptions.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string.isRequired,
  radioProps: PropTypes.array,
  label: PropTypes.string.isRequired,
  desc: PropTypes.string,
  error: PropTypes.string,
};
